import Selective from './Selective';

export default Selective;
